define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "lodash.debounce", "../../store/Events", "../domain", "../services"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, lodash_debounce_1, Events_1, domain_1, services_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaTypeSrf = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    class WaTypeSrf extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WaId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MaintType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MaintTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MaintIsRetainingInt", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "MaintIsRetainingIntError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InspectionFrequency", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InspectionFrequencyError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsWateringAtSrf", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsWateringAtSrfError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsRemovingFromSrf", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsRemovingFromSrfError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermissionType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermissionTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Purpose", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PurposeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CommunityPurpose", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CommunityPurposeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaterRemovalMethod", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaterRemovalMethodError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaterPointSetup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaterPointSetupError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrRegulationMethod", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrRegulationMethodError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrMinVolume", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrMinVolumeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrFractionRemaining", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrFractionRemainingError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrOfftakePlacement", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrOfftakePlacementError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrOfftakeSize", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrOfftakeSizeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrTankCapacity", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrTankCapacityError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrStorageType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrStorageTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsElectricityAtSr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsElectricityAtSrError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrElectricitySrPc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrElectricitySrPcError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrElectricityLoPc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrElectricityLoPcError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Wa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "changeEventBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isPermissionTypeEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isElecLoUsagePcEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isElecTravellingStockPcEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isWaterRemovalMethodEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isSrfStorageTypeEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isWaterUseRegulationMethodEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isFractionOfWaterStorageReqEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isMinVolOfWaterStorageReqEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isOfftakeSetupDistanceEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isMaxOfftakePipeDiameterEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isLoMaxWaterStorageCapacityEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isViewLoWaterFacilityEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isLoWaterPointSetupEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "waterUseRegulationValuesNotApplicable", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "isMaintDataCaptureEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isMaintIsLoRetainingAnInterestEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isMaintInspFreqEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isMaintLoPcEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "maintLoPcMinNumber", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "maintLoPcMaxNumber", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, WaTypeSrf.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Wa = parent;
            this.WaId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Wa = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WaId = (0, EntityUtil_1.toInt)(entity.WaId);
            a.MaintType = (0, EntityUtil_1.toInt)(entity.MaintType);
            a.MaintIsRetainingInt = (0, EntityUtil_1.toInt)(entity.MaintIsRetainingInt);
            a.InspectionFrequency = (0, EntityUtil_1.toInt)(entity.InspectionFrequency);
            a.IsWateringAtSrf = (0, EntityUtil_1.toInt)(entity.IsWateringAtSrf);
            a.IsRemovingFromSrf = (0, EntityUtil_1.toInt)(entity.IsRemovingFromSrf);
            a.PermissionType = (0, EntityUtil_1.toInt)(entity.PermissionType);
            a.Purpose = (0, EntityUtil_1.toInt)(entity.Purpose);
            a.CommunityPurpose = b.CommunityPurpose;
            a.WaterRemovalMethod = (0, EntityUtil_1.toInt)(entity.WaterRemovalMethod);
            a.WaterPointSetup = b.WaterPointSetup;
            a.SrRegulationMethod = (0, EntityUtil_1.toInt)(entity.SrRegulationMethod);
            a.SrMinVolume = (0, EntityUtil_1.toInt)(entity.SrMinVolume);
            a.SrFractionRemaining = (0, EntityUtil_1.toInt)(entity.SrFractionRemaining);
            a.SrOfftakePlacement = (0, EntityUtil_1.toFloat)(entity.SrOfftakePlacement);
            a.SrOfftakeSize = (0, EntityUtil_1.toInt)(entity.SrOfftakeSize);
            a.SrTankCapacity = (0, EntityUtil_1.toInt)(entity.SrTankCapacity);
            a.SrStorageType = (0, EntityUtil_1.toInt)(entity.SrStorageType);
            a.IsElectricityAtSr = (0, EntityUtil_1.toInt)(entity.IsElectricityAtSr);
            a.SrElectricitySrPc = (0, EntityUtil_1.toFloat)(entity.SrElectricitySrPc);
            a.SrElectricityLoPc = (0, EntityUtil_1.toFloat)(entity.SrElectricityLoPc);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.changeEventBatchFn = (0, lodash_debounce_1.default)(this.onFacilityPropChange, 500);
            this.addChangeEventAction("IsWateringAtSrf", this.changeEventBatchFn.bind(this));
            this.addChangeEventAction("IsRemovingFromSrf", this.changeEventBatchFn.bind(this));
            this.addChangeEventAction("IsElectricityAtSr", this.changeEventBatchFn.bind(this));
            this.addChangeEventAction("SrElectricityLoPc", this.changeEventBatchFn.bind(this));
            this.addChangeEventAction("SrFractionRemaining", this.changeEventBatchFn.bind(this));
            this.addChangeEventAction("SrRegulationMethod", this.changeEventBatchFn.bind(this));
            this.addChangeEventAction("WaterRemovalMethod", this.onWaterRemovalMethodChanged.bind(this));
            this.addChangeEventAction("SrRegulationMethod", this.onWaterUseRegulationMethodChanged.bind(this));
            this.onFacilityPropChange();
            this.addChangeEventAction("MaintType", this.onEquipmentPropChange.bind(this));
            this.onEquipmentPropChange();
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, WaTypeSrf.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WaId", "Water Agreement ID");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WaId: this.WaId,
                MaintType: this.MaintType,
                MaintIsRetainingInt: this.MaintIsRetainingInt,
                InspectionFrequency: this.InspectionFrequency,
                IsWateringAtSrf: this.IsWateringAtSrf,
                IsRemovingFromSrf: this.IsRemovingFromSrf,
                PermissionType: this.PermissionType,
                Purpose: this.Purpose,
                CommunityPurpose: this.CommunityPurpose,
                WaterRemovalMethod: this.WaterRemovalMethod,
                WaterPointSetup: this.WaterPointSetup,
                SrRegulationMethod: this.SrRegulationMethod,
                SrMinVolume: this.SrMinVolume,
                SrFractionRemaining: this.SrFractionRemaining,
                SrOfftakePlacement: this.SrOfftakePlacement,
                SrOfftakeSize: this.SrOfftakeSize,
                SrTankCapacity: this.SrTankCapacity,
                SrStorageType: this.SrStorageType,
                IsElectricityAtSr: this.IsElectricityAtSr,
                SrElectricitySrPc: this.SrElectricitySrPc,
                SrElectricityLoPc: this.SrElectricityLoPc,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        onFacilityPropChange(change) {
            let requiresGeometryUpdate = false;
            this.disableChangeObserver();
            if (change) {
                if (change.name == "IsWateringAtSrf" || change.name == "IsRemovingFromSrf") {
                    this.WaterRemovalMethod = undefined;
                    this.SrStorageType = undefined;
                    this.SrRegulationMethod = undefined;
                    requiresGeometryUpdate = true;
                    if (this.IsWateringAtSrf == 1 && this.IsRemovingFromSrf == 1) {
                        this.WaterRemovalMethod = domain_1.WaWaterMovementMethodDomain.PipingOrTransportingWater;
                    }
                }
                if (change.name == "IsWateringAtSrf") {
                    if (this.IsWateringAtSrf == 0) {
                        this.PermissionType = undefined;
                    }
                }
                if (change.name == "IsRemovingFromSrf") {
                    if (this.IsRemovingFromSrf == 0) {
                        this.SrFractionRemaining = undefined;
                        this.SrMinVolume = 0;
                    }
                }
                if (change.name == "IsElectricityAtSr") {
                    if (this.IsElectricityAtSr == 1) {
                        this.SrElectricitySrPc = 1 - this.SrElectricityLoPc;
                    }
                    else {
                        this.SrElectricityLoPc = 0;
                        this.SrElectricitySrPc = 0;
                    }
                }
                if (change.name == "SrElectricityLoPc") {
                    if (this.IsElectricityAtSr == 1) {
                        this.SrElectricitySrPc = 1 - this.SrElectricityLoPc;
                    }
                }
            }
            this.isPermissionTypeEnabled = this.IsWateringAtSrf == 1;
            if (this.IsRemovingFromSrf == 0) {
                this.waterUseRegulationValuesNotApplicable = [
                    domain_1.WaRegulationMethodDomain.PlacementOfOfftake,
                    domain_1.WaRegulationMethodDomain.SizeOfOfftakeSetup,
                    domain_1.WaRegulationMethodDomain.BothPlacementAndSizeOfOfftake
                ];
            }
            else {
                this.waterUseRegulationValuesNotApplicable = [];
            }
            this.isElecLoUsagePcEnabled = this.IsElectricityAtSr == 1;
            this.isWaterRemovalMethodEnabled = (this.IsWateringAtSrf == 0 && this.IsRemovingFromSrf == 1);
            if (this.WaterRemovalMethod == domain_1.WaWaterMovementMethodDomain.PipingOrTransportingWater || this.IsWateringAtSrf == 1) {
                this.isSrfStorageTypeEnabled = true;
                this.isWaterUseRegulationMethodEnabled = true;
            }
            else {
                this.isSrfStorageTypeEnabled = false;
                this.isWaterUseRegulationMethodEnabled = false;
            }
            this.isFractionOfWaterStorageReqEnabled = this.SrRegulationMethod == domain_1.WaRegulationMethodDomain.MinimumWaterHeight;
            this.isMinVolOfWaterStorageReqEnabled = this.SrRegulationMethod == domain_1.WaRegulationMethodDomain.MinimumVolume;
            this.isOfftakeSetupDistanceEnabled = (this.SrRegulationMethod == domain_1.WaRegulationMethodDomain.PlacementOfOfftake || this.SrRegulationMethod == domain_1.WaRegulationMethodDomain.BothPlacementAndSizeOfOfftake);
            this.isMaxOfftakePipeDiameterEnabled = (this.SrRegulationMethod == domain_1.WaRegulationMethodDomain.SizeOfOfftakeSetup || this.SrRegulationMethod == domain_1.WaRegulationMethodDomain.BothPlacementAndSizeOfOfftake);
            this.isLoMaxWaterStorageCapacityEnabled = (this.SrRegulationMethod == domain_1.WaRegulationMethodDomain.SizeOfOfftakeSetup || this.SrRegulationMethod == domain_1.WaRegulationMethodDomain.BothPlacementAndSizeOfOfftake);
            this.isViewLoWaterFacilityEnabled = this.IsRemovingFromSrf == 1;
            this.isLoWaterPointSetupEnabled = this.IsRemovingFromSrf == 1;
            if (requiresGeometryUpdate) {
                this.Wa.updateWaterAgreementOnGeometryChange().then(() => {
                    services_1.EventManager.Instance.emit(Events_1.ENTITY_DRAW_EVENT, false);
                });
            }
            this.enableChangeObserver();
        }
        onWaterUseRegulationMethodChanged(change) {
            const { oldVal, newVal } = (0, EntityUtil_1.parseChangeEvent)(change);
            if (oldVal != newVal) {
                this.SrFractionRemaining = undefined;
                this.SrMinVolume = 0;
                this.SrOfftakePlacement = 0;
                this.SrOfftakeSize = 0;
                this.SrTankCapacity = 0;
            }
            this.onFacilityPropChange(change);
        }
        onWaterRemovalMethodChanged(change) {
            const { oldVal, newVal } = (0, EntityUtil_1.parseChangeEvent)(change);
            if (oldVal != newVal) {
                this.SrStorageType = undefined;
                this.SrRegulationMethod = undefined;
            }
            this.onFacilityPropChange(change);
        }
        onEquipmentPropChange(change) {
            this.disableChangeObserver();
            if (change && change.name == "MaintType") {
                this.InspectionFrequency = undefined;
                this.MaintIsRetainingInt = 0;
                this.Wa.LoMaintenancePc = 0;
            }
            if (this.MaintType == domain_1.WaEquipMaintTypeDomain.Major || this.MaintType == domain_1.WaEquipMaintTypeDomain.Routine) {
                this.isMaintDataCaptureEnabled = true;
                this.isMaintInspFreqEnabled = true;
                this.isMaintLoPcEnabled = true;
                this.isMaintIsLoRetainingAnInterestEnabled = this.MaintType == domain_1.WaEquipMaintTypeDomain.Major;
                if (this.MaintType == domain_1.WaEquipMaintTypeDomain.Major) {
                    this.maintLoPcMinNumber = 0.5;
                    this.maintLoPcMaxNumber = 1;
                }
                else if (this.MaintType == domain_1.WaEquipMaintTypeDomain.Routine) {
                    this.maintLoPcMinNumber = 0.1;
                    this.maintLoPcMaxNumber = 0.5;
                }
            }
            else {
                this.isMaintDataCaptureEnabled = false;
                this.isMaintInspFreqEnabled = false;
                this.isMaintLoPcEnabled = false;
                this.isMaintIsLoRetainingAnInterestEnabled = false;
                this.maintLoPcMinNumber = 0;
                this.maintLoPcMaxNumber = 0.1;
            }
            if (!this.Wa.LoMaintenancePc || this.Wa.LoMaintenancePc < this.maintLoPcMinNumber || this.Wa.LoMaintenancePc > this.maintLoPcMaxNumber) {
                this.Wa.LoMaintenancePc = this.maintLoPcMinNumber;
            }
            this.enableChangeObserver();
        }
    }
    exports.WaTypeSrf = WaTypeSrf;
    Object.defineProperty(WaTypeSrf, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WaTypeSrf"
    });
    Object.defineProperty(WaTypeSrf, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Stock Route Facility Agreement"
    });
    Object.defineProperty(WaTypeSrf, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WaId", "MaintType", "MaintIsRetainingInt", "InspectionFrequency", "IsWateringAtSrf", "IsRemovingFromSrf", "PermissionType", "Purpose", "CommunityPurpose", "WaterRemovalMethod", "WaterPointSetup", "SrRegulationMethod", "SrMinVolume", "SrFractionRemaining", "SrOfftakePlacement", "SrOfftakeSize", "SrTankCapacity", "SrStorageType", "IsElectricityAtSr", "SrElectricitySrPc", "SrElectricityLoPc"]
    });
    Object.defineProperty(WaTypeSrf, "WaIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSrf, "MaintTypeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What type of maintenance (if any) will the landowner be performing?"
    });
    Object.defineProperty(WaTypeSrf, "MaintTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSrf, "MaintTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "MaintIsRetainingIntTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Will the landowner retain an interest in replaced equipment?"
    });
    Object.defineProperty(WaTypeSrf, "MaintIsRetainingIntReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "InspectionFrequencyTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "How often will the Local Government inspect the Stock Route Facility to approve/inspect the maintenance undertaken?"
    });
    Object.defineProperty(WaTypeSrf, "InspectionFrequencyDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSrf, "InspectionFrequencyReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "IsWateringAtSrfTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Will the Landowner be watering their stock at the Stock Route Facility?"
    });
    Object.defineProperty(WaTypeSrf, "IsWateringAtSrfReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "IsRemovingFromSrfTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Will the Landowner be piping or removing water from the Stock Route Facility?"
    });
    Object.defineProperty(WaTypeSrf, "IsRemovingFromSrfReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "PermissionTypeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Does the Landholder hold a lease or Permit to Occupy over part of the Network on which the Stock Route Facility is located?"
    });
    Object.defineProperty(WaTypeSrf, "PermissionTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSrf, "PermissionTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "PurposeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "For what purpose is the Landowner accessing the Stock Route Facility?"
    });
    Object.defineProperty(WaTypeSrf, "PurposeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSrf, "PurposeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "CommunityPurposeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 400
    });
    Object.defineProperty(WaTypeSrf, "CommunityPurposeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "How will the water be used for the community purpose. In 20 words or less, finish the following sentence: The Landowner must only use the water for the purpose of…"
    });
    Object.defineProperty(WaTypeSrf, "CommunityPurposeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "WaterRemovalMethodTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "How is the Landowner removing water from the Stock Route Facility?"
    });
    Object.defineProperty(WaTypeSrf, "WaterRemovalMethodDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSrf, "WaterRemovalMethodReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "WaterPointSetupLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1000
    });
    Object.defineProperty(WaTypeSrf, "WaterPointSetupTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Description of the Landowner’s water point setup approved by the Local Government"
    });
    Object.defineProperty(WaTypeSrf, "WaterPointSetupReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "SrRegulationMethodTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "How will the Stock Route Facility water use be regulated?"
    });
    Object.defineProperty(WaTypeSrf, "SrRegulationMethodDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSrf, "SrRegulationMethodReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "SrMinVolumeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What is the minimum volume (in litres) of water required for travelling stock?"
    });
    Object.defineProperty(WaTypeSrf, "SrMinVolumeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "SrFractionRemainingTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What fraction of the water storage must always remain available?"
    });
    Object.defineProperty(WaTypeSrf, "SrFractionRemainingDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSrf, "SrFractionRemainingReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "SrOfftakePlacementTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What distance (in metres) from the top of the water storage must the offtake be placed?"
    });
    Object.defineProperty(WaTypeSrf, "SrOfftakePlacementReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "SrOfftakeSizeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Maximum offtake pipe diameter (in millimetres)"
    });
    Object.defineProperty(WaTypeSrf, "SrOfftakeSizeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "SrTankCapacityTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Maximum capacity (in litres) of the Water Facility water tank in litres"
    });
    Object.defineProperty(WaTypeSrf, "SrTankCapacityReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "SrStorageTypeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What type of storage does the Stock Route Facility have?"
    });
    Object.defineProperty(WaTypeSrf, "SrStorageTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeSrf, "SrStorageTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "IsElectricityAtSrTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Is electricity connected or required at the Stock Route Facility?"
    });
    Object.defineProperty(WaTypeSrf, "IsElectricityAtSrReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "SrElectricitySrPcTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What is the percentage of the water supplied by the stock route facility that is used by travelling stock?"
    });
    Object.defineProperty(WaTypeSrf, "SrElectricitySrPcReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeSrf, "SrElectricityLoPcTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What is the percentage of the water supplied by the stock route facility that is used by the landowner? E.g. if travelling stock only use 10% of the water supplied by the stock route facility, then 90% is used by the Landowner"
    });
    Object.defineProperty(WaTypeSrf, "SrElectricityLoPcReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "WaId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "WaIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "MaintType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "MaintTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "MaintIsRetainingInt", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "MaintIsRetainingIntError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "InspectionFrequency", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "InspectionFrequencyError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "IsWateringAtSrf", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "IsWateringAtSrfError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "IsRemovingFromSrf", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "IsRemovingFromSrfError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "PermissionType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "PermissionTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "Purpose", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "PurposeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "CommunityPurpose", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "CommunityPurposeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "WaterRemovalMethod", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "WaterRemovalMethodError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "WaterPointSetup", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "WaterPointSetupError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrRegulationMethod", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrRegulationMethodError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrMinVolume", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrMinVolumeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrFractionRemaining", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrFractionRemainingError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrOfftakePlacement", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrOfftakePlacementError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrOfftakeSize", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrOfftakeSizeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrTankCapacity", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrTankCapacityError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrStorageType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrStorageTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "IsElectricityAtSr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "IsElectricityAtSrError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrElectricitySrPc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrElectricitySrPcError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrElectricityLoPc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "SrElectricityLoPcError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "Wa", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSrf.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSrf.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSrf.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isPermissionTypeEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isElecLoUsagePcEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isElecTravellingStockPcEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isWaterRemovalMethodEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isSrfStorageTypeEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isWaterUseRegulationMethodEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isFractionOfWaterStorageReqEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isMinVolOfWaterStorageReqEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isOfftakeSetupDistanceEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isMaxOfftakePipeDiameterEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isLoMaxWaterStorageCapacityEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isViewLoWaterFacilityEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isLoWaterPointSetupEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "waterUseRegulationValuesNotApplicable", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSrf.prototype, "onFacilityPropChange", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSrf.prototype, "onWaterUseRegulationMethodChanged", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSrf.prototype, "onWaterRemovalMethodChanged", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isMaintDataCaptureEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isMaintIsLoRetainingAnInterestEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isMaintInspFreqEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "isMaintLoPcEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "maintLoPcMinNumber", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeSrf.prototype, "maintLoPcMaxNumber", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeSrf.prototype, "onEquipmentPropChange", null);
});
